import { useState, useEffect } from 'react';

const Home = () => {
  const [videoLoaded, setVideoLoaded] = useState(false);
  
  useEffect(() => {
    const video = document.getElementById('video_background');
    
    if (video) {
      // Use canplay event for faster response
      video.addEventListener('canplay', () => {
        setVideoLoaded(true);
      });
      
      // Fallback - force show after 5 seconds even if not fully loaded
      const timeout = setTimeout(() => {
        setVideoLoaded(true);
      }, 5000);
      
      return () => clearTimeout(timeout);
    }
  }, []);

  return (
    <div id="home" style={{ position: 'relative', height: '100vh', overflow: 'hidden', backgroundColor: '#000' }}>
      {/* Elegant loading screen - matches site aesthetic */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: '#000000',
          zIndex: videoLoaded ? -2 : 3,
          opacity: videoLoaded ? 0 : 1,
          transition: 'opacity 1.5s ease-out',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div style={{
          textAlign: 'center',
          animation: 'fadeIn 0.8s ease-out'
        }}>
          {/* Brand name - same style as main content */}
          <div className="home-big-text" style={{
            fontSize: 'clamp(32px, 8vw, 120px)',
            letterSpacing: 'clamp(2px, 0.5vw, 8px)',
            marginBottom: '30px'
          }}>
            The Midnight Edits
          </div>
          
          {/* Elegant line divider */}
          <div style={{
            width: '200px',
            height: '1px',
            background: 'linear-gradient(90deg, transparent, #d4af37, transparent)',
            margin: '0 auto 40px',
            animation: 'lineGrow 1.5s ease-out'
          }} />
          
          {/* Spinning circle loader */}
          <div style={{
            width: '50px',
            height: '50px',
            margin: '0 auto',
            border: '1px solid rgba(212, 175, 55, 0.2)',
            borderTopColor: '#d4af37',
            borderRadius: '50%',
            animation: 'spin 1.2s linear infinite'
          }} />
        </div>
      </div>
      
      {/* Video background - fixed path */}
      <video 
        autoPlay 
        loop 
        muted 
        playsInline
        preload="auto"
        id="video_background"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0
        }}
      >
        <source src="/videos/home-video-optimized.webm" type="video/webm" />
        <source src="/videos/home-video-optimized.mp4" type="video/mp4" />
      </video>

      {/* Dark overlay for better text readability */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(0, 0, 0, 0.3)',
        zIndex: 1
      }} />

      {/* Content overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        textAlign: 'center',
        opacity: videoLoaded ? 1 : 0,
        transform: videoLoaded ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 1.5s ease-out 0.5s, transform 1.5s ease-out 0.5s'
      }}>
        <div className="line"></div>
        
        <div className="home-big-text" style={{
          fontSize: 'clamp(32px, 8vw, 120px)',
          letterSpacing: 'clamp(2px, 0.5vw, 8px)'
        }}>The Midnight Edits</div>
        
        <div className="home-small-text" style={{
          fontSize: 'clamp(12px, 2vw, 24px)',
          letterSpacing: 'clamp(1px, 0.2vw, 3px)',
          marginTop: '20px'
        }}>Where Every Frame Tells a Story</div>
        
        <div className="line1"></div>
      </div>

      {/* CSS Animations */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes lineGrow {
          from { 
            width: 0;
            opacity: 0;
          }
          to { 
            width: 200px;
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default Home;
